import { MAP_TYPES } from '@deck.gl/carto';

const SIMILAR_TRACTS_SOURCE_ID = 'similarTractsSource';

function source(tractcode, year) {
  return {
    id: SIMILAR_TRACTS_SOURCE_ID,
    type: MAP_TYPES.QUERY,
    connection: 'carto_dw',
    data: `
      SELECT DISTINCT
        a.tractcode, a.countyname, a.statename
      FROM
        carto-dw-ac-cn5bemsi.shared.tracts a
      INNER JOIN (
        SELECT neighbor_geoid
        FROM carto-dw-ac-cn5bemsi.shared.tracts_with_closest_neighbours
        WHERE geoid = (
          SELECT DISTINCT geoid
          FROM carto-dw-ac-cn5bemsi.shared.tracts
          WHERE tractcode = ${tractcode}
        )
        ORDER BY distance DESC
        LIMIT 100
      ) b
      ON a.geoid = b.neighbor_geoid
      JOIN carto-dw-ac-cn5bemsi.shared.tract_observations AS observations
        ON a.geoid = observations.geoid
      WHERE observations.year = ${year}
      LIMIT 5
    `,
    queryParameters: {
      tractcode,
      year,
    },
  };
}

export default source;
